import create from 'zustand';

import { pickDraft } from './draft';

/**
 * Store-ын action-ууд массив/объектуудыг ЗАСВАРЛАДАГ (`addressDetails[key] = ...`)
 * тул анхны төлвийг функцээр буцаана — нэг ижил instance-ыг хуваалцвал
 * `resetStore` тэглэж чадахгүй болно.
 */
const createInitialState = () => ({
  step1Values: {},
  /**
   * 1-р алхмын формын утгууд бөглөж байх зуур (`onValuesChange`). `step1Values`
   * нь алхмыг БАТАЛСАН үеийн утга — хоёрыг хольж болохгүй.
   */
  step1FormValues: undefined,
  //   addresses: {},
  addresses: [],
  addressDetails: {},
  /**
   * Захиалга тус бүрийн газрын зургаас сонгосон хаяг (бүтэн объект). Алхам
   * солиход Step1 unmount болдог тул зургийн сонголтыг ЭНД хадгална — эс бөгөөс
   * буцаж ирэхэд сонголт нь алга болно.
   */
  selectedAddresses: {},
  customFieldsList: [],
  reference: undefined,
  products: [],
  positions: {},
  deliveryTime: 'regular',
  deliveryType: 'delivery', //ppbox or delivery
});

/**
 * Захиалгын дугаараар (Form.List-ийн `name`) индекслэсэн объектоос нэгийг хасаад
 * дараагийнхыг нэгээр ахиулна — массивын `splice`-тэй ижил.
 *
 * Step1 нь `positions[index]`, `addressDetails[index]`-ээр уншдаг тул захиалга
 * устгахад индексүүд ахихгүй бол сонгосон байрлал/хаяг өөр захиалга дээр
 * хадаад, эсвэл бүрмөсөн алга болдог.
 */
const removeAtIndex = (source = {}, index) => {
  const removed = Number(index);

  return Object.entries(source).reduce((next, [key, value]) => {
    const position = Number(key);
    if (Number.isNaN(position)) {
      next[key] = value;
      return next;
    }
    if (position === removed) return next;

    next[position > removed ? position - 1 : position] = value;
    return next;
  }, {});
};

const useAddExpressDeliveryStore = create((set, get) => ({
  ...createInitialState(),

  setStep1Values: (values) => {
    if (!values) {
      set((state) => ({ ...state, step1Values: {} }));
    } else {
      set((state) => ({
        ...state,
        step1Values: { ...state.step1Values, ...values },
      }));
    }
  },
  setStep1FormValues: (values) => {
    set((state) => ({ ...state, step1FormValues: values }));
  },
  /**
   * sessionStorage-д хадгалсан draft-аас төлвийг сэргээнэ (Add.js). Зөвхөн
   * draft-д байх талбаруудыг авна — API-аас уншигддаг `reference`, `products`
   * зэрэг нь хадгалагддаггүй.
   */
  hydrate: (draft) => {
    set((state) => ({ ...state, ...pickDraft(draft) }));
  },
  resetStore: () => {
    set(createInitialState());
  },
  setAddressDetails: (key, detail) => {
    const addressDetails = get().addressDetails;
    addressDetails[key] = detail;
    set((state) => ({ ...state, addressDetails }));
  },
  setDeliveryTime: (value) => {
    let deliveryTime = get().deliveryTime;
    deliveryTime = value;
    set((state) => ({ ...state, deliveryTime }));
  },

  /** Тухайн захиалгын хаягийг цэвэрлэнэ (хаяг сольсон үед) — индекс ахихгүй */
  clearAddressDetails: (key) => {
    const addressDetails = { ...get().addressDetails };
    delete addressDetails[key];
    set((state) => ({ ...state, addressDetails }));
  },
  /** Захиалга устгасан үед — дараагийн захиалгуудын хаяг нэгээр ахина */
  removeAddressDetails: (key) => {
    set((state) => ({ ...state, addressDetails: removeAtIndex(state.addressDetails, key) }));
  },
  /** Газрын зургаас сонгосон хаяг (Order.js → AddressMap-ын `selectedAddress`) */
  setSelectedAddress: (key, address) => {
    set((state) => ({
      ...state,
      selectedAddresses: { ...state.selectedAddresses, [key]: address },
    }));
  },
  /** Хаягаа гараас сольсон үед зургийн сонголт хүчингүй болно — индекс ахихгүй */
  clearSelectedAddress: (key) => {
    const selectedAddresses = { ...get().selectedAddresses };
    delete selectedAddresses[key];
    set((state) => ({ ...state, selectedAddresses }));
  },
  /** Захиалга устгасан үед — дараагийн захиалгуудын сонголт нэгээр ахина */
  removeSelectedAddress: (key) => {
    set((state) => ({ ...state, selectedAddresses: removeAtIndex(state.selectedAddresses, key) }));
  },
  setAddressPosition: (key, position) => {
    const positions = get().positions;
    positions[key] = position;
    set((state) => ({ ...state, positions }));
  },
  /** Захиалга устгасан үед — дараагийн захиалгуудын байрлал нэгээр ахина */
  removeAddressPosition: (key) => {
    set((state) => ({ ...state, positions: removeAtIndex(state.positions, key) }));
  },
  setAddresses: (key, type, value) => {
    let copyAddresses = get().addresses;
    copyAddresses[key] ??= {};
    copyAddresses[key][`${type}`] = value;
    set(() => ({ addresses: copyAddresses }));
  },
  removeAddress: (key) => {
    let copyAddresses = get().addresses;
    copyAddresses?.splice(key, 1);
    set(() => ({ addresses: copyAddresses }));
  },

  setCustomFields: (key, value) => {
    let copyList = get().customFieldsList;
    copyList[key] = value;
    set(() => ({ customFieldsList: copyList }));
  },

  removeCustomFields: (key) => {
    let copyList = get().customFieldsList;
    copyList?.splice(key, 1);
    set(() => ({ customFieldsList: copyList }));
  },

  setReference: (ref) => {
    set(() => ({ reference: ref }));
  },

  setProducts: (products) => {
    set(() => ({ products }));
  },
}));

export default useAddExpressDeliveryStore;
